module.exports = __webpack_public_path__ + "static/img/7.112a55d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/7.png
// module id = KOXL
// module chunks = 0